module.exports = __webpack_public_path__ + "static/media/logo_main.93b4e95e.png";